


import { SvgIcon, SvgIconProps } from "@mui/material";

export const SkipNextIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M18 6.75v10.5"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12.925 11.121 6.586 7.159A1.037 1.037 0 0 0 5 8.038v7.923c0 .814.896 1.311 1.586.879l6.338-3.962a1.035 1.035 0 0 0 .001-1.757v0Z" clip-rule="evenodd"/></svg>
    </SvgIcon>
  );
};